export default __webpack_public_path__ + "static/media/flight2.90cc5e3e.jpg";